import getApiClient from '@/plugins/api-client'

export default {
  resend: function () {
    const api = getApiClient(this.$store)
    const id = this.transaction['@id'].replace('/transactions/', '')

    this.$store.commit('app/startLoading')
    api.post(`/transaction/${id}/resend_nfe`, {})
      .then(result => {
        this.resultMessage = result.data.message
      })
      .catch(error => {
        this.resultMessage = error.response.data.message
      })
      .finally(() => {
        this.showResultDialog = true
        this.$store.commit('app/stopLoading')
      })
  },

  generate: function () {
    const api = getApiClient(this.$store)
    const id = this.transaction['@id'].replace('/transactions/', '')

    this.$store.commit('app/startLoading')
    api.post(`/transaction/${id}/generate_nfe`, {})
      .then(result => {
        this.transaction.nfe = {
          id: result.data.nfeId,
        }
        this.resultMessage = 'Solicitação de NFSe enviada.'
      })
      .catch(error => {
        this.resultMessage = error.response.data.message
      })
      .finally(() => {
        this.showResultDialog = true
        this.$store.commit('app/stopLoading')
      })
  },
}
